import {
  BundleProduct,
  MONOCHROMIC_PRODUCTS,
  isBundleProduct,
} from "../lib/models/Products";

import { toTitleCase } from "../util/strings";

const allStyles = [
  "Thin",
  "ExtraLight",
  "Light",
  "Regular",
  "Medium",
  "SemiBold",
  "Bold",
];

const textFontFamily = "ST Monochromic Regular";

const Monochromic = {
  name: "Monochromic",
  subtitle: "Friendly, positive, and uplifting.",
  accentColor: "yellow",
  secondaryAccentColor: "blue",
  fineTextColor: "fedblue",
  defaultStyle: "Monochromic Medium",
  variableCssName: "ST Monochromic Variable",
  styleGroups: [
    {
      name: "Monochromic",
      fontStyles: MONOCHROMIC_PRODUCTS.filter((product) =>
        [15, 16, 17, 18, 19, 20, 21].includes(product.id)
      ),
    },
    {
      name: "Monochromic Script",
      fontStyles: MONOCHROMIC_PRODUCTS.filter((product) =>
        [22, 23, 24, 25, 26, 27, 28].includes(product.id)
      ),
    },
  ],
  stylePurchaseBundles: MONOCHROMIC_PRODUCTS.filter(
    isBundleProduct
  ) as BundleProduct[],
  textFontFamily,
  headerFontFamily: "ST Monochromic Bold",
  specimenRows: [
    "Mae Jemison",
    "Kalpana Chawla",
    "José Hernandez",
    "Ellen Ochoa",
    "Guion S. Bluford",
    "Chawla Koichi",
  ].map((name, i) => {
    return {
      fontName: `Monochromic ${toTitleCase(allStyles[i])}`,
      fontFamily: `ST Monochromic ${allStyles[i]}`,
      fontText: name,
      group: "Monochromic Sans",
    };
  }),
  info: {
    description: (
      <>
        <p style={{ fontFamily: textFontFamily }}>
          Friendly and contemporary, Felicette is a sans-serif with charm. It is
          fitting on occasions that call for a friendly face, while not
          compromising on the need for a clean-cut geometric sans. It's elegant,
          lovable and good-looking — just like Félicette, its namesake Parisian
          cat who was sent into space!
        </p>
        <p style={{ fontFamily: textFontFamily }}>
          In future releases, the upright family will be accompanied by a
          script-style family, rather than the traditional sloped or italic
          styles, to further emphasize its friendliness.
        </p>
      </>
    ),
    languagesSupported:
      "Albanian, Asu, Basque, Bemba, Bena, Breton, Catalan, Chiga, Colognian, Cornish, Croatian, Czech, Danish, Dutch, English, Estonian, Faroese, Filipino, Finnish, French, Friulian, Galician, Ganda, German, Gusii, Hungarian, Inari, Sami, Indonesian, Irish, Italian, Jola-Fonyi, Kabuverdianu, Kalenjin, Kinyarwanda, Koyra, ChiiniLatvian, Koyraboro, Senni, Lithuanian, Lower Sorbian, LuoLuxembourgish, Luyia, Machame, Makhuwa-Meetto, Makonde, Malagasy, Maltese, Manx, Marshallese, Moldavian, Morisyen, North Ndebele, Northern Sami, Norwegian Bokmål, Norwegian,  Nynorsk, Nyankole, Oromo, Polish, Portuguese, Quechua, Romanian, Romansh, Rombo, Rundi, Rwa, Samburu, Sango, Sangu, Scottish, Gaelic, Sena, Serbian, Shambala, Shona, Slovak, Soga, Somali, Spanish, Swahili, Swedish, Swiss, German, Taita, Tasawaq, Teso, Turkish, Upper Sorbian, Uzbek (Latin), Volapük, VunjoWalser, Welsh, Western Frisian, Zarma, Zulu.",
    collection: "ST Monochromic",
    designers: "Lynne Yun & Tamara Segura",
    release: "2022",
    numWeights: 6,
    numStyles: 12,
    version: "2.1",
    fileFormats: ".otf, .ttf, .woff2",
  },
};

export default Monochromic;
